(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-carousel"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
const $slider = document.querySelector(".banner-carousel");

if($slider) {
  new Swiper($slider.querySelector(".swiper"), {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      observer: true,
      observeParents: true,
      pagination: {
          el: $slider.querySelector(".swiper-pagination"),
          type: "bullets",
      }
  });
}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !window.DesignMode) return;
  try {
    
document.addEventListener('alpine:init', () => {
    Alpine.data('collection', () => ({
        activeCollection: "{{  section.blocks.first.settings.collection.handle }}",
        async init() {
            console.log('collection');

            const response = await fetch(`${window.Shopify.routes.root}collections/{{ section.blocks.first.settings.collection.handle }}?sort_by=best-selling&sections=section-best-sellers-products`)
            const data = await response.json();
            const rootEl = document.getElementById('best-sellers-collection');
            const products = rootEl.querySelector('.products-listing');

            products.innerHTML = data['section-best-sellers-products'];
        },
        async loadCollection(event) {
            const handle = event.target.getAttribute('data-handle');

            if(!handle) return;

            this.activeCollection = handle;

            const response = await fetch(`${window.Shopify.routes.root}collections/${handle}?sort_by=best-selling&sections=section-best-sellers-products`)
            const data = await response.json();
            const rootEl = document.getElementById('best-sellers-collection');
            const products = rootEl.querySelector('.products-listing');

            products.innerHTML = data['section-best-sellers-products'];
        }
    }))
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    function initEyebrow() {
        const slides = document.querySelectorAll('.eyebrow-slider .swiper-slide');
        const slidesLength = slides ? slides.length : 0;

        new Swiper(".eyebrow-slider", {
            autoplay: slidesLength > 1 ? { delay: 5000 } : false,
            slidesPerView: 1,
            slidesPerGroup: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            observer: true,
            observeParents: true,
            on: {
                init: function(swiper) {
                    swiper.$el.removeClass('hidden').addClass('flex');
                }
            }
        });
    }

    document.addEventListener("DOMContentLoaded", initEyebrow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["judgeme-carousel"] && !window.DesignMode) return;
  try {
    
class ReviewCarousel extends window.HTMLElement {
    constructor(el) {
        super();

        this.el = el;
        this.isInit = false;
        this.isEmpty = false;
        this.reviewsByProductId = null;
        this.products = [];
        this.sectionId = this.getAttribute('section-id');

        this.render();
    }

    get isInit() {
        return this.hasAttribute('isInit');
    }

    set isInit(val) {
        if (val) {
            this.setAttribute('isInit', '');
        } else {
            this.removeAttribute('isInit');
        }
    }

    async fetchProduct(handle) {
        if(!handle) return null;
        
        try {
            const product = await fetch(window.Shopify.routes.root+ `products/${handle}?view=review`)
                .then(response => response.json());
                
            return product;
        } catch (error) {
            return null;
        }
    }

    async fetchAllProducts(handles) {
        try {
        const promises = handles.map(handle => this.fetchProduct(handle));
        const products = await Promise.all(promises);

        // Filter out null values
        const results = products.filter(product => product !== null);

        return results;
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async connectedCallback() {
        // Runs when the element is added to the document
        try {
            const reviews = await fetch(`https://wooltari-qmlofqf3ja-uc.a.run.app/judgeme?locale=${window.Shopify.locale}`)
                .then(response => response.json())
                .catch(error => console.error('Error:', error));

            if(!reviews || reviews.length === 0) {
                this.isInit = true;
                this.isEmpty = true;

                const sectionElement = document.getElementById(`shopify-section-${this.sectionId}`);

                if(sectionElement) {
                    sectionElement.style.display = 'none';
                }

                this.render();
                return;
            }
    
            if(reviews) {
                const reviewsByProductId = {};
    
                reviews.forEach(review => {
                    if(!reviewsByProductId[review.product_id]) {
                        reviewsByProductId[review.product_id] = {
                            ...review
                        };
                    }
                });
    
                this.reviewsByProductId = reviewsByProductId;
    
                const productHandles = reviews.map(item => item.product_handle);
    
                try {
                    const products = await this.fetchAllProducts(productHandles);
                    const reviewProducts = products.map(product => {
                        if(!this.reviewsByProductId[product.id]) {
                            return {...product, reivew: null};
                        }
    
                        const review = this.reviewsByProductId[product.id];
    
                        return {
                            ...product,
                            review
                        };
                    });
    
                    this.isInit = true;
                    this.products = reviewProducts;
                    this.render();
                } catch (error) {
                    console.error('Error:', error);
                    this.isInit = false;
                }
            }
        } catch (error) {
            
        }
    }

    static get observedAttributes() {
        return ['isInit', 'isEmpty'];
    }
 
    attributeChangedCallback(property, oldValue, newValue) {
        if (oldValue === newValue) return;


        this[property] = newValue;

    }

    initializeSwiper() {
        const swiperContainer = this.querySelector('.review-carousel');

        if (swiperContainer) {
            new window.Swiper(swiperContainer, {
                loop: true,
                loopAdditionalSlides: 3,
                autoplay: {
                    delay: 4000,
                },
                centeredSlides: true,
                slidesPerView: 1.4,
                spaceBetween: 16,
                breakpoints: {
                    768: {
                        centeredSlides: false,
                        slidesPerView: 3,
                        spaceBetween: 16,
                    }
                }
            });
        }
    }

    renderSwiper() {
        const items = this.products.map(product => {
            const pictures = product.review?.pictures || [];
            const reviewPictures = pictures.slice(0, 2);

            return `
                <div class="swiper-slide">
                    <div class="bg-white p-4 rounded-lg shadow-md cursor cursor-pointer border border-gray-200 block" x-data x-on:click="
                        window.location.href='${window.Shopify.routes.root}products/${product.handle}';
                    ">
                        <div class="">
                            <div>
                                <div class="grid grid-cols-2 gap-2">
                                    ${reviewPictures.map(picture => {
                                        return `<div class="pb-[100%] relative"><img src="${picture.urls.original}&w=340" alt="Review" class="border border-gray-100 rounded-md w-full object-cover absolute inset-0 h-full"></div>`
                                    }).join('')}
                                </div>
                                <div class="mt-4 pb-2 border-gray-100">
                                    <h4 class="hidden capitalize font-semibold text-sm mb-1">${product.review?.reviewer}</h4>
                                    <div class="flex flex-row items-center">
                                        <svg class="text-primary h-4 w-4" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                        </svg><svg class="text-primary h-4 w-4" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                        </svg><svg class="text-primary h-4 w-4" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                        </svg><svg class="text-primary h-4 w-4" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                        </svg><svg class="text-primary h-4 w-4" fill="currentColor" viewbox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                                        </svg>    
                                    </div>
                                </div>
                                <p class="line-clamp-3 text-[15px] lg:text-base h-[66px] lg:h-[72px] break-words">
                                    ${product.review?.body}
                                </p>
                            </div>
                            <div class="flex flex-row lg:items-center mt-3 bg-gray-100 px-2 py-2" style="min-height: 79px">
                                <div class="flex-shrink-0 mr-4">
                                    <img src="${product.image}" class="w-12 h-12 lg:w-20 lg:h-20 border border-gray-100 rounded-md" alt="${product.title}">
                                </div>
                                <div class="flex-1 min-h-[48px]">
                                    <h3 class="font-medium leading-tight text-black/90 line-clamp-2 text-sm lg:text-[15px] break-words">${product.title}</h3>
                                    <div class="flex flex-row items-center mt-1">
                                        <p class="text-primary text-base lg:text-lg font-bold ${!product.on_sale ? 'hidden' : 'mr-1'}">${product.discount}</p>
                                        <p class="text-black/90 text-base lg:text-lg font-bold">$${product.price}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
        });

        return `
            <div class="review-carousel swiper-container">
                <div class="swiper-wrapper">
                    ${items.join('')}
                </div>
            </div>
        `;
    }

    render() {
        this.innerHTML = `
            <div>
                ${this.isInit ? this.isEmpty ? '' : this.renderSwiper() : `<div class="px-4"><div class="flex justify-center flex-row flex-wrap -mx-2">
                    <div class="w-[80%] lg:w-1/3 px-2">
                        <div class="pb-[100%] bg-gray-50  border border-gray-200 rounded-lg shadow-md relative">
                            <div class="absolute inset-0 w-full h-full px-4 py-4">
                                <div class="grid grid-cols-2 gap-2">
                                    <div class="pb-[100%] bg-gray-100 rounded-md"></div>
                                    <div class="pb-[100%] bg-gray-100 rounded-md"></div>
                                </div>
                                <div class="mt-2 space-y-2">
                                    <div class="h-3 block bg-gray-100"></div>
                                    <div class="h-3 block bg-gray-100"></div>
                                    <div class="h-3 w-2/3 bg-gray-100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hidden lg:block lg:w-1/3 px-2">
                        <div class="pb-[100%] bg-gray-50  border border-gray-200 rounded-lg shadow-md relative">
                            <div class="absolute inset-0 w-full h-full px-4 py-4">
                                <div class="grid grid-cols-2 gap-2">
                                    <div class="pb-[100%] bg-gray-100 rounded-md"></div>
                                    <div class="pb-[100%] bg-gray-100 rounded-md"></div>
                                </div>
                                <div class="mt-2 space-y-2">
                                    <div class="h-3 block bg-gray-100"></div>
                                    <div class="h-3 block bg-gray-100"></div>
                                    <div class="h-3 w-2/3 bg-gray-100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="hidden lg:block lg:w-1/3 px-2">
                        <div class="pb-[100%] bg-gray-50  border border-gray-200 rounded-lg shadow-md relative">
                            <div class="absolute inset-0 w-full h-full px-4 py-4">
                                <div class="grid grid-cols-2 gap-2">
                                    <div class="pb-[100%] bg-gray-100 rounded-md"></div>
                                    <div class="pb-[100%] bg-gray-100 rounded-md"></div>
                                </div>
                                <div class="mt-2 space-y-2">
                                    <div class="h-3 block bg-gray-100"></div>
                                    <div class="h-3 block bg-gray-100"></div>
                                    <div class="h-3 w-2/3 bg-gray-100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div></div>`}
            </div>
        `;

        this.initializeSwiper();
    }
}

window.customElements.define("review-carousel", ReviewCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
let carousel;

  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const $swiper = recommendations.querySelector('.swiper');

          if($swiper && window.innerWidth >= 1024) {
            carousel = new Swiper('.product-recommendations .swiper',{
                loop: false,
                freeMode: {
                    enabled: true,
                    sticky: false,
                },
                // noSwipingSelector: '.quick-add',
                // allowTouchMove: true,
                // mousewheel: {
                //     invert: false,
                //     forceToAxis: true,
                // },
                // watchSlidesProgress: true,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                slidesPerView: 2.5,
                spaceBetween: 8,
                preventClicks: true,
                a11y: false,
                parallax:true,
                observer: true,
                observeParents: true,
                breakpoints: {
                    768: {
                        slidesPerView: 3.5,
                        spaceBetween: 16,
                    },
                    1024: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        freeMode: false,
                        slidesPerView: 5,
                        slidesPerGroup: 2,
                        spaceBetween: 24,
                    },
                    1280: {
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        freeMode: false,
                        slidesPerView: 6,
                        slidesPerGroup: 2,
                        spaceBetween: 24,
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
          } else {
            if(carousel && carousel?.destroyed !== false) {
                carousel.destroy(true, true);
                carousel = undefined
            }
          }
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

    function renderResponsiveVideo(e) {
        if(window.innerWidth >= 1024) {
            if(!carousel) {
                carousel = new Swiper('.product-recommendations .swiper', {
                    loop: false,
                    freeMode: {
                        enabled: true,
                        sticky: false,
                    },
                    slidesOffsetBefore: 16,
                    slidesOffsetAfter: 16,
                    slidesPerView: 2.5,
                    spaceBetween: 8,
                    preventClicks: true,
                    a11y: false,
                    parallax:true,
                    observer: true,
                    observeParents: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 3.5,
                            spaceBetween: 16,
                        },
                        1024: {
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            freeMode: false,
                            slidesPerView: 5,
                            slidesPerGroup: 2,
                            spaceBetween: 24,
                        },
                        1280: {
                            slidesOffsetBefore: 0,
                            slidesOffsetAfter: 0,
                            freeMode: false,
                            slidesPerView: 6,
                            slidesPerGroup: 2,
                            spaceBetween: 24,
                        },
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }
                });
            }
        } else {
            console.log('has', carousel);
            if(carousel) {
                carousel.destroy(true, true);
                carousel = undefined;
            }
            $('.product-recommendations .swiper-wrapper').removeAttr('style');
            $('.product-recommendations .swiper-slide').removeAttr('style');
            console.log('dest', carousel);
        }
    };

    window.addEventListener("resize", _.debounce(renderResponsiveVideo), 200)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion"]) return;
  try {
    
const $slider = document.querySelector(".promotion-slider");

if($slider) {
  new Swiper($slider.querySelector(".swiper"), {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 16,
      loop: true,
      loopAdditionalSlides: 2,
      observer: true,
      observeParents: true,
      pagination: {
          el: $slider.querySelector(".swiper-pagination"),
          type: "bullets",
      },
      navigation: {
          nextEl: $slider.querySelector(".swiper-button-next"),
          prevEl: $slider.querySelector(".swiper-button-prev"),
      },
  });
}


  } catch(e) { console.error(e); }
})();
})();
